import { render, staticRenderFns } from "./InputSigarusNumber.vue?vue&type=template&id=fce03130&"
import script from "./InputSigarusNumber.vue?vue&type=script&lang=js&"
export * from "./InputSigarusNumber.vue?vue&type=script&lang=js&"
import style0 from "./InputSigarusNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports